import { Info } from 'lucide-react';

export function MockDataBanner() {
  return (
    <div
      role="note"
      className="mx-7 mt-6 flex items-start gap-2.5 rounded-md bg-spark-s/60 px-3.5 py-2.5 text-[12.5px] leading-snug text-spark hair border border-spark/30"
    >
      <Info size={14} strokeWidth={2.2} className="mt-px flex-shrink-0" />
      <div>
        <span className="font-semibold">Mock data preview.</span>{' '}
        <span className="text-ink-3">
          Every number, name, and event on this page is placeholder content for design review — not
          tenant data.
        </span>
      </div>
    </div>
  );
}
